import { cva, type VariantProps } from 'class-variance-authority';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export const headingVariants = cva('leading-[130%]', {
  variants: {
    variant: {
      h1: cn('scroll-m-20 font-bold text-4xl leading-[130%]', 'xl:text-5xl'),
      h2: 'scroll-m-20 font-bold text-4xl leading-[130%]',
      h3: cn('scroll-m-20 font-bold text-2xl leading-[130%]', 'xl:text-[32px]'),
      h4: cn('scroll-m-20 font-bold text-xl leading-[130%]', 'xl:text-2xl'),
      h5: cn('scroll-m-20 font-bold text-lg leading-[130%]', 'xl:text-xl'),
      h6: 'scroll-m-20 font-bold text-lg leading-[130%]',
    },
  },
  defaultVariants: {
    variant: 'h1',
  },
});

export function Heading({
  className,
  variant = 'h1',
  ...props
}: ComponentProps<'h1'> & VariantProps<typeof headingVariants>): JSX.Element {
  const Comp: TAny = variant;

  return (
    <Comp
      className={cn(
        headingVariants({
          variant,
          className,
        }),
      )}
      {...props}
    />
  );
}
